export default function setSearchProductSystemAction(searchProductSystem) {
    return {
        type: 'SET_SEARCH_PRODUCT_SYSTEM',
        payload: searchProductSystem
    }
}